module.exports = __webpack_public_path__ + "static/media/canimolt_BannersCenso_INFOGRAFIA.5d7b0c9b.jpg";